export function avoirReducer(state = "",{
    type,
    payload
}){
    switch(type){
        
        case "GET_AVOIRS":
            return payload;
        
        default:
            return state;
    }
}